var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.00016 1.16659C3.7785 1.16659 1.16683 3.77826 1.16683 6.99992C1.16683 10.2216 3.7785 12.8333 7.00016 12.8333C10.2218 12.8333 12.8335 10.2216 12.8335 6.99992C12.8335 3.77826 10.2218 1.16659 7.00016 1.16659Z",
    fill: "#4BFF5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 8.74988L7.875 6.99988L6.125 5.24988",
    stroke: "#021A04",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewFeedbackIcon);
export default __webpack_public_path__ + "static/media/ReviewFeedbackIcon.2c1a16d3a8d02b10156e8267b828eaaf.svg";
export { ForwardRef as ReactComponent };